export default "__VITE_ASSET__CKRoFiMj__"